export default __webpack_public_path__ + "static/media/266.d297e8aa.jpg";